import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import openingsmaller from './img/AuditAttack/openingsmaller.png';
import clientjump from './img/AuditAttack/clientjump.png';
import clienthighscore from './img/AuditAttack/clienthighscore.png';
import manendlessaudit from './img/AuditAttack/manendlessaudit.png';
import levelthreeaudit from './img/AuditAttack/levelthreeaudit.png';


export const AuditAttack = ({}) => {



	return (
		<div className="container-fluid appdesc corners">
<div className="row padrow">
 <div className="col-md-8 col-lg-8">
			 <h2>Audit Attack!</h2>
 </div>
	<div className="col-md-4 col-lg-4">
			 <a href='https://play.google.com/store/apps/details?id=com.froggy1.AuditAttack&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' className="appimage img-responsive d-block mx-auto auditpic googlebadge"/></a>
 </div>
 </div>
<div className="row padrow">
<div className="col-md-12 col-lg-12">
			Contentious audit?  Release some steam with Audit Attack - play in Client or Audit Mode!
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={openingsmaller} alt="Opening screen of AuditAttack Application" className="appimage img-responsive img-thumbnail d-block mx-auto auditpic"/>
</div>

 </div>
			 <div className="row padrow">
			 <div className="col-md-6 col-lg-6 col-md-border">
			 <h2>Company Accountants Read This Right Now!</h2>
 <p> Overwhelmed by incessant audit requests just as you're trying to get out the door?  Get past those persistent pests so you can relax and have free time.</p>
	<img src={clientjump} alt="Play Screen of client mode of AuditAttack Application" className="appimage img-responsive img-thumbnail d-block mx-auto auditpic"/>
			 <p>Five levels of play with bigger and badder auditors topped off by endless mode.  See how many auditors you can defeat before you are overwhelmed with audit work.</p>
			 <img src={clienthighscore} alt="High Score Screen of client mode of AuditAttack Application" className="appimage img-responsive img-thumbnail d-block mx-auto auditpic"/>
 </div>
			 <div className="col-md-6 col-lg-6">
			 <h2>External or Internal Auditors Read This!</h2>
 <p> Client leaving at five while you labor until midnight?  Stop those clients from leaving and get that audit evidence on time and under budget.</p>
	<img src={levelthreeaudit} alt="Play Screen of client mode of AuditAttack Application" className="appimage img-responsive img-thumbnail d-block mx-auto auditpic"/>
			 <p>Five levels of play with increasingly senior opponents topped off by endless mode.  See how many clients you can defeat before you are overrun with their stampede out the door.</p>
			 <img src={manendlessaudit} alt="High Score Screen of client mode of AuditAttack Application" className="appimage img-responsive img-thumbnail d-block mx-auto auditpic"/>
 </div>
 </div>


			 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 <p>Note that the free version contains banner ads in all screens.</p>

			 </div>
 </div>

</div>
			)


}
